import React, { Component, createRef } from 'react';
import Grid from '@mui/material/Grid';
import { Tooltip } from '@mui/material';
import { TipTapEditor } from '../TipTap';

/**
 * APITextEditor - Minimal editor for Slack and similar components
 * 
 * No toolbar, outputs HTML, supports $ placeholders.
 * Used by SlackTemplate.js
 */
class TextEditor extends Component {
  editorRef = createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      content: this.normalizeContent(this.props.html),
    };
    if (this.props.editorFocus) {
      this.props.editorFocus();
    }
  }

  normalizeContent(html) {
    let content = html;
    if (content) {
      content = content.replace(/(?:\r\n|\r|\n)/g, '<br>');
    } else {
      content = '';
    }
    return content;
  }

  componentDidUpdate(prevProps) {
    // Handle placeholder insertion via props
    const { placeholder } = this.props;
    if (placeholder && placeholder.length !== prevProps.placeholder?.length) {
      this.insertPlaceholder(placeholder[placeholder.length - 1]);
    }
  }

  insertPlaceholder = (placeholder) => {
    if (placeholder && this.editorRef.current) {
      this.editorRef.current.insertPlaceholder(placeholder);
    }
  };

  handleChange = (value) => {
    this.setState({ content: value });
  };

  handleBlur = (value) => {
    // Clean up newlines
    let cleanValue = value.replace(/(?:\n)/g, '');
    if (this.props.onChange) {
      this.props.onChange(cleanValue);
    }
  };

  render() {
    const { content, loading } = this.state;
    const { readOnly, availablePlaceholders } = this.props;

    if (loading) {
      return (
        <div className="my-nice-tab-container">
          <div className="loading-state"></div>
        </div>
      );
    }

    return (
      <Tooltip 
        placement="bottom" 
        title='Type "$" to view and insert placeholders'
        enterDelay={1200}
        enterNextDelay={1200}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TipTapEditor
              ref={this.editorRef}
              value={content}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              showToolbar={false}
              stripHtml={false}
              triggerChars={['$']}
              availablePlaceholders={availablePlaceholders}
              readOnly={readOnly || false}
              variant="outlined"
              placeholder=""
            />
          </Grid>
        </Grid>
      </Tooltip>
    );
  }
}

export default TextEditor;
